export default () => ({
  incidents:[],
  currentincident:[]
})
